<template>
  <div>
    <div class="package-orders-stage">




      <PackagesManagerOrdersCentralListGrouped/>

    </div>
  </div>
</template>

<script>
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import PackagesManagerOrdersCentralListGrouped
  from "@/views/PackagesManager/PackagesManagerOrdersCentralListGrouped.vue";

export default {
  name: "PackagesManagerOrdersCentralStage",
  components: {PackagesManagerOrdersCentralListGrouped },
  data(){
    return {





    };
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
  },
  methods: {

  },
  watch: {
  },
  created() {
    this.simplepharmAuth.refreshToken().then(()=>{
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    })

  },
};
</script>

<style scoped>
.package-orders-stage {


}
</style>
